import { CommonModule } from "@angular/common"
import { Component, Inject, LOCALE_ID } from "@angular/core"
import { MatDialog } from "@angular/material/dialog"
import { Meta, Title } from "@angular/platform-browser"
import { SisespService } from "../../services/sisesp.service"
import { Curso } from "../../models/curso.model"
import { MatExpansionModule } from "@angular/material/expansion"
import { MatIconModule } from "@angular/material/icon"
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms"
import { MatAutocompleteModule } from "@angular/material/autocomplete"
import { MatFormFieldModule } from "@angular/material/form-field"
import { MatInputModule } from "@angular/material/input"
import { MatSelectModule } from "@angular/material/select"
import { forkJoin, catchError, of, Observable, startWith, map } from "rxjs"
import { MatButtonModule } from "@angular/material/button"

@Component({
  selector: 'app-curso-listar',
  imports: [
    CommonModule,
    MatExpansionModule,
    MatIconModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule
  ],
  templateUrl: './curso-listar.component.html',
  styleUrls: ['./curso-listar.component.scss']
})
export class CursoListarComponent {

  loadFail: boolean = false
  localesList = [
    { path: '../pt/lato-sensu/', label: 'Português - Brasil', image: 'assets/icons/locale-pt.png' },
    { path: '../en/lato-sensu/', label: 'English', image: 'assets/icons/locale-en.png' }
  ]

  inscricaoAbertaDB: Curso[] = []
  proximosDB: Curso[] = []
  emAndamentoDB: Curso[] = []

  inscricaoAberta: Curso[] = []
  proximos: Curso[] = []
  emAndamento: Curso[] = []

  cursos: string[] = []
  cursoFiltered: Observable<string[]> | undefined
  modalidades: string[] = []
  cidades: string[] = []

  form = new FormGroup({
    nomeCurso: new FormControl(''),
    modalidade: new FormControl(''),
    cidade: new FormControl('')
  })

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private sisespService: SisespService,
    private meta: Meta,
    private title: Title,
    public dialog: MatDialog,
  ) {
    this.ajustaTagsHtml()
    this.loadData()
  }

  private ajustaTagsHtml() {
    this.title.setTitle('Especialização UNESP Pós-graduação Lato sensu')
    this.meta.updateTag({ name: 'description', content: 'A Unesp é uma das universidades públicas estaduais de SP, ao lado USP e Unicamp, com programas de pós-graduação, entre cursos de mestrado e doutorado, credenciados pela Capes.' })
  }

  private loadData(): void {
    forkJoin({
      inscricaoAberta: this.sisespService.inscricaoAberta().pipe(
        catchError(err => {
          this.loadFail = true
          return of(null)
        })
      ),
      proximos: this.sisespService.proximos().pipe(
        catchError(err => {
          this.loadFail = true
          return of(null)
        })
      ),
      emAndamento: this.sisespService.emAndamento().pipe(
        catchError(err => {
          this.loadFail = true
          return of(null)
        })
      ),
    }).subscribe({
      next: (results) => {
        results.inscricaoAberta?.forEach(c => {c.areaConhecimento = c.areaConhecimento.substring(0,1)})
        results.proximos?.forEach(c => {c.areaConhecimento = c.areaConhecimento.substring(0,1)})
        results.emAndamento?.forEach(c => {c.areaConhecimento = c.areaConhecimento.substring(0,1)})
        this.inscricaoAbertaDB = results.inscricaoAberta ?? []
        this.proximosDB = results.proximos ?? []
        this.emAndamentoDB = results.emAndamento ?? []
        this.inscricaoAberta = results.inscricaoAberta ?? []
        this.proximos = results.proximos ?? []
        this.emAndamento = results.emAndamento ?? []
        if (!this.loadFail) {
          this.inscricaoAberta.forEach(curso => {
            if (this.cursos.indexOf(curso.nome) === -1) {
              this.cursos.push(curso.nome)
            }
            if (this.modalidades.indexOf(curso.modalidade) === -1) {
              this.modalidades.push(curso.modalidade)
            }
            if (this.cidades.indexOf(curso.cidade) === -1) {
              this.cidades.push(curso.cidade)
            }
          })
          this.proximos.forEach(curso => {
            if (this.cursos.indexOf(curso.nome) === -1) {
              this.cursos.push(curso.nome)
            }
            if (this.modalidades.indexOf(curso.modalidade) === -1) {
              this.modalidades.push(curso.modalidade)
            }
            if (this.cidades.indexOf(curso.cidade) === -1) {
              this.cidades.push(curso.cidade)
            }
          })
          this.emAndamento.forEach(curso => {
            if (this.cursos.indexOf(curso.nome) === -1) {
              this.cursos.push(curso.nome)
            }
            if (this.modalidades.indexOf(curso.modalidade) === -1) {
              this.modalidades.push(curso.modalidade)
            }
            if (this.cidades.indexOf(curso.cidade) === -1) {
              this.cidades.push(curso.cidade)
            }
          })
          this.cidades.sort()

          this.cursoFiltered = this.form.controls.nomeCurso.valueChanges.pipe(
            startWith(''),
            map(value => {
              if (value) {
                const pesquisa = (value as string).trim().toString().normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase()
                return this.cursos.filter(curso => curso.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '').includes(pesquisa))
              } else {
                // return this.linhas.slice() // retorna a lista para que a pessoa possa escolher
                return [] // a lista está em branco e só após digitar será apresetando a lista já com o filtro digitado
              }
            })
          )
        }
      },
      error: () => {
        this.loadFail = true
      }
    })
  }

  limpar(field: string): void {
    this.form.get(field)?.setValue('')
    this.pesquisar()
  }

  pesquisar(): void {
    const nomeCurso = this.form.controls.nomeCurso.getRawValue()!
    const modalidade = this.form.controls.modalidade.getRawValue()!
    const cidade = this.form.controls.cidade.getRawValue()!
    this.inscricaoAberta = this.inscricaoAbertaDB.filter(curso => (nomeCurso === '' || curso.nome == nomeCurso) && (modalidade === '' || curso.modalidade == modalidade) && (cidade === '' || curso.cidade == cidade))
    this.proximos = this.proximosDB.filter(curso => (nomeCurso === '' || curso.nome == nomeCurso) && (modalidade === '' || curso.modalidade == modalidade) && (cidade === '' || curso.cidade == cidade))
    this.emAndamento = this.emAndamentoDB.filter(curso => (nomeCurso === '' || curso.nome == nomeCurso) && (modalidade === '' || curso.modalidade == modalidade) && (cidade === '' || curso.cidade == cidade))
  }

  validarFiltroNomeCurso(): void {
    const valorNoInput = this.form.controls.nomeCurso.getRawValue()
    if (!this.cursos.includes(valorNoInput!)) {
      this.form.controls.nomeCurso.setValue('')
      this.pesquisar()
    }
  }

  selecionarCurso(value: string): void {
    this.form.controls.nomeCurso.setValue(value)
    this.pesquisar()
  }

  acessar(id: number): void {
    this.sisespService.acessar(id)
  }

  openLink(url: string): void {
    window.open(`${url}`, '_blank')
  }
}